import { get, pick, values, isEmpty } from 'lodash-es';
import {
  ADDRESS_STATUS,
  ADDRESS_CLASSIFICATION,
  SMARTYSTREETS_DPV_MATCH_CODES as DPV_MATCH_CODES,
} from '../constants';

const STATUS_MAP = {
  [DPV_MATCH_CODES.CONFIRMED]: ADDRESS_STATUS.VALID,
  [DPV_MATCH_CODES.NOT_CONFIRMED]: ADDRESS_STATUS.INVALID,
  [DPV_MATCH_CODES.CONFIRMED_DROPPING_SECONDARY]: ADDRESS_STATUS.INVALID,
  [DPV_MATCH_CODES.CONFIRMED_MISSING_SECONDARY]: ADDRESS_STATUS.APT_NEEDED,
};

// Order matters here!
const STREET_COMPONENTS = [
  'primary_number',
  'street_predirection',
  'street_name',
  'street_suffix',
  'street_postdirection',
];

export function parseSmartyStreetsResponse(response) {
  const analysis = response.analysis || {};
  const components = response.components || {};
  const metadata = response.metadata || {};
  const address = parseAddress(components);
  const statusAndClass = {
    status: parseStatus(analysis, metadata),
    classification: parseClassification(analysis, metadata),
  };
  const smartyStreetsElements = {
    analysis,
    components,
    metadata,
  };

  return isEmpty(response)
    ? statusAndClass
    : Object.assign(address, smartyStreetsElements, statusAndClass);
}

function parseAddress(components) {
  const street = parseStreet(components);

  return {
    // Need to set `street` and `base_street` for now.
    // TODO: Remove once / if we ever get rid of street / base_street concept
    base_street: street,
    street,
    apt: get(components, 'secondary_number', null),
    city: get(components, 'city_name', null),
    state: get(components, 'state_abbreviation', null),
    zip: get(components, 'zipcode', null),
    add_on_zip: get(components, 'plus4_code', null),
  };
}

function parseClassification(analysis, metadata) {
  if (isMilitary(analysis, metadata)) {
    return ADDRESS_CLASSIFICATION.MILITARY;
  }

  return (metadata.rdi || ADDRESS_CLASSIFICATION.UNKNOWN).toLowerCase();
}

function isMilitary({ footnotes = '', dpv_footnotes = '' }, { zip_type }) {
  // 1. Match made to a record with a military or diplomatic ZIP Code.
  // 2. Matched to military or diplomatic address.
  // 3. The ZIP Code pertains to military units and diplomatic organizations,
  // often in foreign locations.
  return (
    footnotes.includes('Y#') ||
    dpv_footnotes.includes('F1') ||
    zip_type === 'Military'
  );
}

function parseStatus(analysis, metadata) {
  return STATUS_MAP[analysis.dpv_match_code] || ADDRESS_STATUS.INVALID;
}

function parseStreet(components) {
  return values(pick(components, STREET_COMPONENTS))
    .filter(property => !!property)
    .join(' ');
}
